import { gql } from '@apollo/client';

export const GET_VOLUNTEER_UNAVAILABILITIES = gql`
  query GetVolunteerUnavailabilities($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        unavailabilities {
          volunteerUnavailabilityId
          startDate
          endDate
        }
      }
    }
  }
`;